<script lang="ts">
	import { screenWidthClass } from '$lib/stores/resizeStore';
	import ModalView from './ModalView.svelte';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import Size from './size';
	import ConfirmModal from '$lib/components/Modal/ConfirmModal.svelte';

	export let isOpen = false;
	export let showCloseButton = true;
	export let type: Size = Size.Auto;
	export let closeIconClass = 'closeIcon';
	export let confirmationOnClose = '';
	export let disableClose = false;

	let isConfirmDisplayed = false;

	export let onClose = () => {
		// Empty function
	};

	const beforeCloseModal = () => {
		if (confirmationOnClose) {
			isConfirmDisplayed = true;
		} else {
			closeModal();
		}
	};

	const closeModal = () => {
		isOpen = false;
		onClose();
	};

	const onEscape = (e: KeyboardEvent) => {
		if (e.key === 'Escape') beforeCloseModal();
	};
</script>

<svelte:body on:keyup={onEscape} />

<div class="placeholder">
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<span class="holder" on:click={() => (isOpen = true)}><slot name="target" /></span>
	{#if isOpen}
		<ModalView {type} closeModal={beforeCloseModal}>
			<div>
				<div class="title" class:showCloseButton>
					<slot name="title" />
					{#if showCloseButton}
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<!-- svelte-ignore a11y-no-static-element-interactions -->
						<div class="close" on:click|stopPropagation={beforeCloseModal}>
							<Icon icon="close" size="24" className={closeIconClass} />
						</div>
					{/if}
				</div>
				<div class={`content ${type} ${$screenWidthClass}`}>
					<slot name="content" />
				</div>
			</div>
		</ModalView>
	{/if}
	{#if isConfirmDisplayed && !disableClose}
		<ConfirmModal
			content={confirmationOnClose}
			isOpen={isConfirmDisplayed}
			onSubmit={closeModal}
			onCancel={() => (isConfirmDisplayed = false)} />
	{/if}
</div>

<style>
	.placeholder {
		position: relative;
	}

	.holder {
		position: relative;
		cursor: pointer;
	}

	.title {
		display: flex;
		position: relative;
		align-items: center;
		justify-content: center;
		inline-size: 100%;
		padding: 2rem;
	}

	.close {
		position: absolute;
		inset-inline-end: 2rem;
	}

	:global(.closeIcon) {
		opacity: 0.8;
		cursor: pointer !important;
	}

	:global(.closeIcon:hover) {
		opacity: 1;
	}

	.content.small.screenWidthSmallest > :global(:first-child),
	.content.small.screenWidthSmall > :global(:first-child) {
		block-size: 200px;
		inline-size: 100vw;
		line-height: 1.5;
	}

	.content.small.screenWidthMedium > :global(:first-child),
	.content.small.screenWidthLarge > :global(:first-child) {
		block-size: auto;
		inline-size: fit-content;
		white-space: nowrap;
	}

	.content.medium.screenWidthSmallest > :global(:first-child),
	.content.medium.screenWidthSmall > :global(:first-child) {
		block-size: auto;
		inline-size: 100vw;
	}

	.content.medium.screenWidthMedium > :global(:first-child),
	.content.medium.screenWidthLarge > :global(:first-child) {
		block-size: 60vh;
		inline-size: 500px;
	}

	.content.large.screenWidthMedium > :global(:first-child),
	.content.large.screenWidthLarge > :global(:first-child) {
		block-size: 80vh;
		inline-size: 60vw;
	}
</style>
